var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_3084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 15.5703V34.5003C44.0001 36.0307 43.4153 37.5033 42.3654 38.6168C41.3155 39.7303 39.8798 40.4005 38.352 40.4903L38 40.5003H10C8.46958 40.5004 6.99697 39.9157 5.88348 38.8657C4.76999 37.8158 4.09978 36.3801 4.01 34.8523L4 34.5003V15.5703L22.89 28.1643L23.122 28.2963C23.3954 28.4299 23.6957 28.4993 24 28.4993C24.3043 28.4993 24.6046 28.4299 24.878 28.2963L25.11 28.1643L44 15.5703Z",
    fill: " #5C0E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0006 8.5C40.1606 8.5 42.0546 9.64 43.1106 11.354L24.0006 24.094L4.89062 11.354C5.39209 10.5395 6.08105 9.8568 6.90004 9.36277C7.71903 8.86873 8.64429 8.57771 9.59862 8.514L10.0006 8.5H38.0006Z",
    fill: " #5C0E80"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_3084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.15adf53214f796d37fcf653b14dbe7cc.svg";
export { ForwardRef as ReactComponent };